const URLS = {
    OAUTH: '/oauth',
    GET_PROFILE: '/v4/manage/user/profile',
    GET_SUBSCRIPTIONS: '/v4/manage/user/subscriptions',
    GET_ACTIVE_SUBSCRIPTIONS: 'v4/manage/user/subscriptions/active',
    GET_INACTIVE_SUBSCRIPTIONS: 'v4/manage/user/subscriptions/inactive',
    GET_WHATS_HOT: '/v4/manage/ecal-world/whats-hot',
    GET_DISCOVER_PUBLISHERS: '/v4/manage/ecal-world/discover-publishers',
    GET_FEATURED_PUBLISHERS: '/v4/manage/ecal-world/featured-publishers',
    GET_NEAR_ME: '/v4/manage/ecal-world/near-me',
    GET_TRENDING_NEAR_ME: '/v4/manage/ecal-world/trending-near-me',
    GET_RECOMMENDATIONS: '/v4/manage/user/recommendations',
    GET_TOTAL_SUBSCRIBERS: '/v4/manage/ecal-world/total-subscriptions',
};

export default URLS;
